$(document).ready(function () {

    $(document).on("click", ".confirmLink", function (e) {
        e.preventDefault();
        let link = $(this);
        let ask = "Opravdu chcete odebrat tento záznam?";

        if (isDefined(link.data("ask"))) {
            ask = link.data("ask");
        }

        let confirmDialog = new ConfirmDialog(ask, {
            event: e
        });

        confirmDialog.create(function (result) {
            if (result) {
                let url = link.data("href");
                let ajax = link.data("ajax");
                let snippetsOff = link.data("snippets-off");
                if (snippetsOff == 'true' || snippetsOff == '1') {
                    snippetsOff = true;
                } else {
                    snippetsOff = false;
                }
                let callback = link.data("callback");

                if (ajax === "on") {
                    $.nette.ajax({
                        url: url,
                        off: {
                            snippets: snippetsOff
                        },
                        success: function (payload) {
                            if (callback != null) {
                                callback = "handle" + callback;
                                window[callback](payload);
                            }
                        }
                    });
                } else {
                    window.location.href = url;
                }
            }
        });

    });

});

$(document).ready(function () {

    if (isDefined($.fn.select2)) {
        $(".select2").select2();
    }

    $('.custom-file-input').on('change', function () {
        let fileName = this.files[0].name;
        $(this).siblings('.custom-file-label').first().addClass("selected").html(fileName);
    });

});





